module.exports = "/images/vendor/flag-icon-css/flags/1x1/zm.svg?3eef5dc07668374a4628c322fdf6c937";